/* Module for Portfolio Analyst */

export const types = {
}

const state = {
}

const getters = {

    hasBalanceSummary(state, getters, rootState, rootGetters) {
        return ($build.mode == 'production' && !rootGetters.isPaperUser && !rootGetters.isFreeTrial) || $build.mode == 'development';
    }

}

const mutations = {
}

const actions = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
